<app-modal-template
  [title]="title"
  [size]="renderedAsMatBottomSheet ? pencilModalSizeEnum.FULL_WIDTH : size"
  [hasCloseButton]="hasCloseButton"
  [ngStyle]="{
    '--modal-template-gap': description && descriptionGap ? '24px' : '0px'
  }"
  (closeButtonClicked)="handleCloseButtonClick($event)"
>
  <div *ngIf="showBodyImg && bodyImg" class="confirmation-modal-img-container" content-img>
    <img
      class="confirmation-modal-img"
      [src]="bodyImg.url"
      [attr.alt]="bodyImg.alt ?? ''"
      [style.max-width]="bodyImg.width ?? null"
      [style.max-height]="bodyImg.height ?? null"
      loading="eager"
      decoding="async"
    />
  </div>
  <div *ngIf="description" class="confirmation-modal-description" content-description>
    <div class="descriptions-box" [innerHtml]="description"></div>
  </div>
  <div class="actions-box" content-actions>
    <ng-container *ngIf="!customCancelButton">
      <app-pencil-button
        *ngIf="cancelButtonConfig"
        [theme]="'secondary-outline'"
        [icon]="cancelButtonConfig.icon"
        [iconConfig]="{ type: cancelButtonConfig.iconType }"
        [label]="cancelButtonConfig.label"
        (clickEvent)="handleCancelClick($event)"
      ></app-pencil-button>
    </ng-container>
    <ng-content select="[custom-cancel-button]"></ng-content>
    <app-pencil-button
      *ngIf="confirmButtonConfig"
      [theme]="confirmButtonConfig.danger ? 'danger' : 'primary'"
      [icon]="confirmButtonConfig.icon"
      [iconConfig]="{ type: confirmButtonConfig.iconType, outlined: confirmButtonConfig.outlined }"
      [label]="confirmButtonConfig.label"
      (clickEvent)="handleConfirmClick($event)"
      (mouseenter)="handleConfirmButtonHovered(true)"
      (mouseleave)="handleConfirmButtonHovered(false)"
    ></app-pencil-button>
  </div>
</app-modal-template>
